import React, { useState, useEffect, useCallback,useRef  } from "react";
import { useSignalAbort } from "../../api/useSignalAbort";
import { handleApiErrors } from "../../api/handleApiErrors";
import * as employerAdminApi from "../../api/employerAdminApi";
import Table from 'react-bootstrap/Table';
import { CSVLink } from 'react-csv';
import { BiExport } from "react-icons/bi";
import { Spinner,Button } from 'react-bootstrap';
import { MdFilterList } from "react-icons/md";
import { convertDateForDisplay,convertDateForApi, dateFormat } from "../../HelperFile";
import { IoIosSearch } from "react-icons/io";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Dropdown } from 'react-bootstrap';
import { IoIosClose } from 'react-icons/io'; 

function Reports() {
  const abortConstants = useSignalAbort();
  const [employerFormData, setEmployerFormData] = useState([]);
  const [isLoading, setIsLoading] = useState({});

  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const handleFilterIconClick = () => {
    setShowDropdown(!showDropdown);
  };

  const handleStartDateChange = date => {
    setStartDate(date);
  };

  const handleEndDateChange = date => {
    setEndDate(date);
  };

  useEffect(() => {
    getAllData(abortConstants.controllerConfig)
  },[])

  const getAllData = (abortToken) =>{
    getEmployerForm(startDate,endDate,abortToken)
    
  }


  const getEmployerForm = async (frmDate,toDate,  abortToken) => {
    setIsLoading(true);
    const startDate = convertDateForApi(frmDate)
    console.log(startDate);
  const endDate=convertDateForApi(toDate)
  console.log(endDate);

    try {
      const result = await employerAdminApi.getEmployerForm(startDate,endDate,  abortToken);
      
      if(result){
        setIsLoading(false);
      }
     
      setEmployerFormData(result?.data?.EmployerForm || []);
    } catch (error) {
      handleApiErrors(error, 'EmployerForm', 'employerForm_response', 'employerForm_timeout', 'employerForm_request', setIsLoading);
      setIsLoading(false);
    }finally {
      setIsLoading(false);
    }
  };

 

  const renderLoading = (item) => {
    if (isLoading[`${item}_response`] || isLoading[`${item}_request`] || isLoading[`${item}_timeout`]) {
      return true;
    } else {
      return false;
    }
  }
// Add a CSS class for table cells
const cellStyle = {
  maxWidth: '100px', // Set your preferred max-width value
  overflow: 'hidden',
  // whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
};
  const headers = [
    { label: 'Company Name', key: 'CompanyName' },
    { label: 'Job Title', key: 'JobTitle' },
    { label: 'Contact Name', key: 'ContactName' },
    { label: 'Contact Number', key: 'ContactNo' },
    { label: 'Email Id', key: 'EmailId' },
    { label: 'Website', key: 'Website' },
    { label: 'Nationality', key: 'Nationality' },
    { label: 'State Name', key: 'StateName' },
    { label: 'Country Name', key: 'CountryName' },
    { label: 'Job Description', key: 'JobDescription' },
    { label: 'Other Queries', key: 'OtherQueries' },
    { label: 'Created Date', key: 'CreatedDate' },
  ];

  return (
    <div style={{ margin: '20px', width: '100%' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h2 style={{ fontSize: '1.5rem', marginBottom: '0' }}>Employer Form</h2>

        <div style={{ textAlign: 'end', marginBottom: '10px' }}>
        <MdFilterList className="filter-icon-button" onClick={handleFilterIconClick}  size={20} style={{ marginRight: '40px', color: '#172446' }} />
        <Dropdown.Menu 
        ref={dropdownRef}
        show={showDropdown}
        style={{ position: 'absolute', top: 100, right: 24, zIndex: 999 }}
      >
 {/* Close Icon */}
 <div style={{ textAlign: 'right', paddingRight: '10px', cursor: 'pointer' }} onClick={() => setShowDropdown(false)}>
        <IoIosClose size={24} />
    </div>

        <h5 style={{  textAlign:'center',color:'#172446'}}>Created Between:</h5>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', padding: '10px' }}>
    <div className="datepicker-with-icon" style={{ marginRight: '10px' }}>
      <DatePicker
        selected={startDate}
        onChange={handleStartDateChange}
        selectsStart
        startDate={startDate}
        endDate={endDate}
        dateFormat = {dateFormat()}
        placeholderText="dd-MM-yyyy"
      />
    </div>  
    <div style={{ margin: '0 10px' }}>-</div>

    <div className="datepicker-with-icon">
      <DatePicker
        selected={endDate}
        onChange={handleEndDateChange}
        selectsEnd
        startDate={startDate}
        endDate={endDate}
        minDate={startDate}
        dateFormat = {dateFormat()}
        placeholderText="dd-MM-yyyy"
      />
    </div>
  </div>

        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', padding: '10px' }}    >
     <Button  
      style={{backgroundColor:'#172446',color:'#FFFFFF',border:'none'}} 
        
       onClick={() => {
        setShowDropdown(false); // Close the dropdown
        getEmployerForm(startDate, endDate, abortConstants.controllerConfig);
      }} 
        >
    {isLoading ? (
            <>
              <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2"/>
              Searching...
            </>
          ) : (
         'Search'
    )}
    </Button>

  </div>
        
      </Dropdown.Menu>
        
        
        <CSVLink data={employerFormData} headers={headers} filename={"employerFormData.csv"}>
        <BiExport size={20} style={{ marginRight: '5px', color: '#172446', cursor: 'pointer'}}/>
        </CSVLink>
        </div>  
      </div>
      <div style={{height:'600px',overflow:'auto' ,marginTop: '20px'}}>
      {renderLoading("employerForm") || employerFormData === null ? (
          <div style={{ height: '350px', display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '15px' }}>
            {employerFormData === null ? "No data" : <Spinner animation="border" role="status" style={{ color: '#2855A1' }} />}
          </div>
        ) : (
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Company Name</th>
                <th>Job Title</th>
                <th>Contact Name</th>
                <th>Contact Number</th>
                <th>Email Id</th>
                <th>Website</th>
                <th>Nationality</th>
                <th>State Name</th>
                <th>Country Name</th>
                <th>Job Description</th>
                <th>Other Queries</th>
                <th>Created Date</th>
              </tr>
            </thead>
            <tbody>
              {employerFormData.map((item, index) => (
                <tr key={index}>
                  <td style={cellStyle}>{item.CompanyName}</td>
                  <td style={cellStyle}>{item.JobTitle}</td>
                  <td style={cellStyle}>{item.ContactName}</td>
                  <td style={cellStyle}>{item.ContactNo}</td>
                  <td style={cellStyle}>{item.EmailId}</td>
                  <td style={cellStyle}>{item.Website}</td>
                  <td style={cellStyle}>{item.Nationality}</td>
                  <td style={cellStyle}>{item.StateName}</td>
                  <td style={cellStyle}>{item.CountryName}</td>
                  <td style={cellStyle}>{item.JobDescription}</td>
                  <td style={cellStyle}>{item.OtherQueries}</td>
                  <td style={cellStyle}>{convertDateForDisplay(item.CreatedDate)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </div>
    </div>
  );
}

export default Reports;
